import { IMAGE_VARIANTS } from './responsiveImageManifest';

export const IMAGE_WIDTHS = {
  hero: [640, 960, 1280, 1600, 1920],
  logo: [64, 96, 128, 192, 256, 384, 512],
  card: [320, 480, 640, 800, 1024],
  reference: [480, 768, 1024, 1366, 1600, 1920],
  team: [128, 192, 256, 320, 384, 480],
} as const;

const normalizeBase = (base: string) => base.replace(/\\.webp$/, '');

const getAvailableWidths = (base: string) => {
  const normalized = normalizeBase(base);
  return IMAGE_VARIANTS[normalized];
};

const pickClosestWidth = (widths: readonly number[], target: number) => {
  if (!widths.length) return target;
  const exact = widths.find((width) => width === target);
  if (exact) return exact;
  const smaller = widths.filter((width) => width <= target);
  if (smaller.length) return smaller[smaller.length - 1];
  return widths[0];
};

export const buildSrc = (base: string, width: number) => {
  const normalized = normalizeBase(base);
  const available = IMAGE_VARIANTS[normalized];
  if (!available) return `${normalized}-${width}.webp`;
  const selected = pickClosestWidth(available, width);
  return `${normalized}-${selected}.webp`;
};

export const buildSrcSet = (base: string, _fallbackWidths: readonly number[]) => {
  const normalized = normalizeBase(base);
  const available = getAvailableWidths(normalized);
  const selected = available ?? [];
  if (!selected.length) return '';
  return selected.map((width) => `${normalized}-${width}.webp ${width}w`).join(', ');
};
